<template>
    <div class="tw:flex tw:items-center tw:justify-center tw:py-10">
        <div class="tw:w-full tw:max-w-3xl tw:bg-white tw:rounded-sm tw:shadow-2xl tw:relative tw:overflow-hidden">
            <div class="tw:absolute tw:top-0 tw:left-0 tw:w-full tw:h-2 tw:bg-red-600"></div>

            <div class="tw:md:px-10 tw:px-5 tw:py-8 tw:text-center">
                <div class="tw:inline-block tw:bg-red-100 tw:text-red-600 tw:font-semibold tw:text-sm tw:px-5 tw:py-2 tw:rounded-full tw:mb-4">
                    {{ $t('presale.badge') }}
                </div>
                <h1 class="tw:text-5xl tw:font-extrabold tw:tracking-wider tw:text-slate-900 tw:mb-8">
                    {{ $t('presale.title') }}
                </h1>
                <p class="tw:text-md tw:text-gray-500 tw:leading-relaxed tw:max-w-2xl tw:mx-auto tw:pb-5">
                    {{ $t('presale.description') }}
                </p>
                <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
                    <div class="tw:text-left tw:max-w-2xl tw:mx-auto">

                        <FormInput
                            :label="$t('presale.access_code_label')"
                            :name="$t('presale.access_code_name')"
                            rules="required"
                            :apiValidationError="errorCodigo"
                            v-model="codigo"
                        />
                        <Button
                            :label="$t('presale.access_button')"
                            class="tw:w-full"
                            type="submit"
                        />
                    </div>
                </ValidationObserver>

                <div class="tw:border-t tw:border-gray-200 tw:my-5"></div>

                <div class="tw:flex tw:justify-between tw:items-center tw:text-sm tw:text-gray-400">
                    <div class="tw:flex tw:items-center tw:space-x-1">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="tw:h-5 tw:w-5 tw:text-green-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 11c1.657 0 3-1.343 3-3V6a3 3 0 10-6 0v2c0 1.657 1.343 3 3 3zm6 2H6a2 2 0 00-2 2v5a2 2 0 002 2h12a2 2 0 002-2v-5a2 2 0 00-2-2z"
                            />
                        </svg>

                        <span class="tw:font-medium tw:text-gray-500 tw:pt-1">
                            {{ $t('presale.secure_connection') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch , getCurrentInstance} from 'vue'
    import Button from '@/modules/ui/Button.vue';

    const codigo = ref('')
    const observer = ref(null)
    const errorCodigo = ref('')
    const { proxy } = getCurrentInstance()

    const emit = defineEmits(['acceder'])

    watch(codigo, newValue => {
        if (!newValue || newValue === 'PUNCHES26') {
            errorCodigo.value = ''
        }
    })

    const submit = async() => {
        errorCodigo.value = ''

        const isValid = await observer.value.validate()
        if (!isValid) return

        if (codigo.value !== 'PUNCHES26') {
            errorCodigo.value = proxy.$t('presale.invalid_code')
            return
        }

        emit('acceder', codigo.value)
    }
</script>